
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { Block } from "../types";

interface EmbedBlockProps {
  block: Block;
  onUpdate: (updates: Partial<Block>) => void;
}

export const EmbedBlock = ({ block, onUpdate }: EmbedBlockProps) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>Embed Type</Label>
        <Select
          value={block.embedType || "iframe"}
          onValueChange={(value: "iframe" | "script" | "html") => 
            onUpdate({ embedType: value })
          }
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="iframe">iFrame</SelectItem>
            <SelectItem value="script">Script</SelectItem>
            <SelectItem value="html">HTML</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-2">
        <Label>Embed Code</Label>
        <Input
          value={block.embedCode || ""}
          onChange={(e) => onUpdate({ embedCode: e.target.value })}
          placeholder="Paste your embed code here"
        />
      </div>
    </div>
  );
};
